import React from 'react';
import SobreNosotros from '../../components/SobreNosotros/SobreNosotros';

const SobreNosotrosPage = () => (
  <>
    <SobreNosotros />
  </>
);

export default SobreNosotrosPage;
